export default __webpack_public_path__ + "static/media/22.0c16549f.jpg";